import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { SYSTEM_PILLARS } from './salesData';
const NOT_THIS: string[] = ['No es otro pack de plantillas', 'No es un curso genérico de marketing', 'No te pide convertirte en especialista en redes'];
export function PositioningSection() {
  return <section className="bg-sand py-12 sm:py-16" data-id="element-166" data-mp="q6hg7qxf2rzb">
      <div className="mx-auto max-w-4xl px-5" data-id="element-167" data-mp="q78zc29tux8p">
        <div className="text-center" data-id="element-168" data-mp="m4vvjjen59ek">
          <SectionTag data-id="element-169" data-mp="m3t2p5xrcww0">El enfoque</SectionTag>
          <h2 className="mt-4 font-display text-[1.7rem] font-semibold leading-tight text-charcoal sm:text-[2.4rem]" data-id="element-170" data-mp="m78n8oa7ay4t">
            Esto no es otro pack de plantillas
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-sans text-sm leading-relaxed text-charcoal/70 sm:text-base" data-id="element-171" data-mp="c8j30ouu11le">
            Vos ya sabés enseñar, acompañar y transformar personas. Wellness Digital PRO te da el
            sistema para comunicar ese valor, crear contenido con intención y convertir atención en
            nuevas consultas.
          </p>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2" data-id="element-172" data-mp="29h6bur1ahf8s">
          {NOT_THIS.map(item => <li key={item} className="inline-flex items-center gap-1.5 rounded-full border border-stone bg-ivory px-3.5 py-1.5 font-sans text-[0.72rem] font-medium text-charcoal/70" data-id="element-173" data-mp="1vhdnh2d8jb3z">
              <XIcon className="h-3.5 w-3.5 shrink-0 text-charcoal/40" aria-hidden data-id="element-174" data-mp="2o5t1blkmrndq" />
              {item}
            </li>)}
        </ul>

        <h3 className="mt-9 text-center font-display text-xl font-semibold leading-tight text-charcoal sm:text-2xl" data-id="element-175" data-mp="2efq04y3cv34b">
          Las 5 funciones que tu Instagram necesita cumplir
        </h3>

        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-id="element-176" data-mp="3745bnana33aw">
          {SYSTEM_PILLARS.map((pillar, i) => <motion.article key={pillar.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="rounded-xl border border-stone bg-ivory p-4" data-id="element-177" data-mp="3buvlb02qlsbe" data-mpi={i}>
              <p className="font-sans text-[0.6rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-178" data-mp="37qtany56gb2c">
                0{i + 1}
              </p>
              <h3 className="mt-1.5 font-display text-lg font-semibold leading-tight text-charcoal" data-id="element-179" data-mp="32si01l725wj2">
                {pillar.title}
              </h3>
              <p className="mt-1 font-sans text-[0.78rem] leading-snug text-charcoal/70" data-id="element-180" data-mp="2t1wvzi8m7zsr">
                {pillar.desc}
              </p>
            </motion.article>)}
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center font-display text-lg font-semibold italic leading-snug text-charcoal sm:text-xl" data-id="element-181" data-mp="2k18q5atdl5qy">
          No se trata de tener más publicaciones. Se trata de que cada parte de tu Instagram tenga
          una función dentro de un sistema pensado para atraer clientes.
        </p>
      </div>
    </section>;
}